import { createContext } from '../../utils/createContext.js';
export const [AccordionProvider, useAccordionContext] = createContext('AccordionContext');
